import { Box, Button, Card, CardContent, CardHeader, Divider } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import { InputLabel, TextField, Grid,Typography } from '@mui/material';
import { useApi, identityApiRef } from '@backstage/core-plugin-api';
import { terraformApiRef } from '@internal/plugin-terraform/src/api';


export default function GeneralSetting() {
    const [name,setName]=useState('')
    const api = useApi(terraformApiRef);
    const identityApi = useApi(identityApiRef)

    const saveOrgDetails=async()=>{
        await api.saveOrgDetails(name)
        // localStorage.setItem('orgName',name)
    }

    const fetchOrgDetail=async()=>{
        let orgName=localStorage.getItem('orgName')
        if(orgName){
            setName(orgName)
        }else{
            const details = await identityApi.getBackstageIdentity();
            const tenantId = details.ownershipEntityRefs.find(ref=>
              ref.startsWith('tenantId:')
            )?.split(':')[1]
            console.log("tenantId in general settings", tenantId)
            let resp= await api.fetchOrgDetails(tenantId)
            if(resp.data.orgDetail){
                setName(resp.data.orgDetail)
                // localStorage.setItem('orgName',resp.data.orgDetail)
            }
        }

    }

    useEffect(()=>{
       fetchOrgDetail()
    })

  return (
    <div style={{height:'100%'}}>

        <Box style={{display:'flex'}}>
            <Card style={{width:'50%',height:'40%'}}>
                <CardHeader title='Organization Details'/>
                <Divider />
                <CardContent>
                    <Grid container spacing={4} style={{padding:'25px'}}>
                        <Grid item xs={12}>
                            <InputLabel style={{margin:'10px'}}>
                                Name : 
                            </InputLabel>
                            <TextField
                            size='small'
                            type='text'
                            label=""
                            value={name}
                            placeholder='Enter Name here'
                            onChange={(event: React.ChangeEvent<HTMLInputElement>)=>{
                                setName(event.target.value)
                            }}
                            InputProps={{
                                sx: {
                                borderRadius: '25px'
                                }
                            }}
                            >
                         
                            </TextField>
                        </Grid>
                        <Grid item xs={12} textAlign="right">
                            <Button disabled={false } variant="outlined"  onClick={() => {saveOrgDetails() }}>Save</Button>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Box>

    </div>
  )
}
